// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.watch__navbar {
  background-color: var(--navbar-watch-bg-color);
}
.watch__navbar .navbar__logo img {
  height: var(--navbar-player-logo-height-mobile);
}
@media (min-width: 1200px) {
  .watch__navbar .navbar__logo img {
    height: var(--navbar-player-logo-height-desktop);
  }
}
.watch__navbar .hamburger-icon.hamburger-icon span {
  background-color: var(--navbar-hamburger-menu-color) !important;
}
.watch__navbar.navbar--affixed {
  background-color: var(--navbar-scrolled-watch-bg-color);
}
.watch__navbar.navbar--affixed .hamburger-icon.hamburger-icon span {
  background-color: var(--navbar-scrolled-hamburger-menu-color) !important;
}
.watch__player-wrapper {
  background-color: #000000;
  padding-right: 80px;
  transition: all 0.3s ease-in-out;
}
@media (max-width: 768px) {
  .watch__player-wrapper {
    padding-right: 0 !important;
  }
}
.watch__player-wrapper--countdown {
  padding-right: 0 !important;
  background-color: transparent;
}
.watch.mobile-right-nav .right-navigation .body {
  right: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Watch/Watch.scss"],"names":[],"mappings":"AAGI;EACI,8CAAA;AAFR;AAKY;EACI,+CAAA;AAHhB;AAKgB;EAHJ;IAIQ,gDAAA;EAFlB;AACF;AAOY;EACI,+DAAA;AALhB;AASQ;EACI,uDAAA;AAPZ;AAUgB;EACI,wEAAA;AARpB;AAcI;EACI,yBAAA;EACA,mBAAA;EACA,gCAAA;AAZR;AAcQ;EALJ;IAMQ,2BAAA;EAXV;AACF;AAaQ;EACI,2BAAA;EACA,6BAAA;AAXZ;AAiBY;EACI,QAAA;AAfhB","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
